import { TOKEN, REFRESH_TOKEN } from 'commons/constants/store';
import storage from '../storage';
import * as jwt from './jwt';

const state = {
  idToken: '',
  refreshToken: '',
  token: {
    exp: 0,
    expAC: 0,
  },
};

/** GETTERS */

function isTokenExpired(exp: number | string | null | undefined) {
  return !exp || new Date().getTime() > Number(exp) * 1000;
}

function hasValidToken(token: string) {
  const parsedToken = jwt.decode(token);
  return token && parsedToken?.exp && new Date().getTime() < parsedToken?.exp * 1000;
}

/** METHODS */

function handleAccessToken(token: string, refreshToken?: string) {
  const parsedToken = jwt.decode(token);

  state.idToken = token;
  state.token.exp = parsedToken?.exp ?? 0;
  state.token.expAC = parsedToken?.expAC ?? 0;

  storage.add(TOKEN, token);

  if (refreshToken) {
    state.refreshToken = refreshToken;
    storage.add(REFRESH_TOKEN, refreshToken);
  }
}

export { state as user, isTokenExpired, hasValidToken, handleAccessToken };
